module.exports = __webpack_public_path__ + "static/img/005城市名片5.39fd9ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/005城市名片5.jpg
// module id = KKsi
// module chunks = 0